import { withStyles } from '@material-ui/core';
import { SpotBanner } from '../../api/models';
import BaseDisplay, { BaseRealProps } from '../basedisplay/BaseDisplay';
import MyTypes from 'MyTypes';
import { bindActionCreators, Dispatch } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ChangeSet } from '@devexpress/dx-react-grid';
import { commonFeatureActions } from '../../features/commonfeature';


const styles = {
    container: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginTop: '3%',
        paddingTop: '3%',
    }
}

const mapStateToProps = (state: MyTypes.RootState) => ({
})

const mapDispatchToProps = (dispatch: Dispatch<MyTypes.RootAction>) => 
    bindActionCreators(
        {
            createSpotBanner: commonFeatureActions.createSpotBanner,
            patchSpotBanner: commonFeatureActions.patchSpotBanner
        },
        dispatch
    )

type MyProps<Data> = BaseRealProps<Data> & ReturnType<typeof mapDispatchToProps>

class SpotBannerDisplay extends BaseDisplay<SpotBanner, MyProps<SpotBanner>> {
    static defaultProps = {
        ...BaseDisplay.defaultProps,
        onCommitEditing: function(changeSet: ChangeSet) {
            const props = this as MyProps<SpotBanner>
            const { added, changed } = changeSet
            const data = (this as any).data
            if (changed != null) {
                for (let rowIndex in changed) {
                    const kv = changed[rowIndex]

                    const rowId = data[Number(rowIndex)].id;
                    (this as any).patchSpotBanner({
                        spotBannerId: rowId,
                        args: {...kv}
                    })
                }
            }
            if (added != null) {
                // TODO change it to coupon banner
                console.log('Adding Spot Banner', added)
                added.forEach(raw => {
                    let isCurrent = raw['isCurrent'] == '1' || raw['isCurrent'] == 'true'
                    let spotId = raw['spotId']
                    let imageId = raw['imageId']
                    console.log(`isCurrent: ${isCurrent} spotID: ${spotId} imageId: ${imageId}`)
                    props.createSpotBanner({
                        isCurrent,
                        spotId,
                        imageId
                    })
                });
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles)(SpotBannerDisplay)))